<template>
  <div :class="`addMember ${!$store.state.isMobile ? 'pcMember' : 'addMember_mobile'}`" @click="clickPage">
    <div class="contentTitle" v-if="!$store.state.isMobile">{{title || '个人信息'}}</div>
    <div class="itemCard">
      <div class="itemCardTitle" v-if="$store.state.isMobile">{{title || '个人信息'}}</div>
      <div class="lineContent">
        <div class="name">姓 名</div>
        <el-input v-model="member.personName" placeholder="请输入姓名" oninput="if(value && value.length>15)value=value.slice(0,15)"></el-input>
      </div>
      <div class="lineContent">
        <div class="name">身份证号</div>
        <el-input v-model="member.cardNum" placeholder="请输入身份证号码"></el-input>
      </div>
      <div class="lineContent">
        <div class="name">联系电话</div>
        <el-input v-model="member.phone" placeholder="请输入联系电话" type="number" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
      </div>
    </div>
    <div class="backButtons">
      <div class="back" @click="back" v-if="title">取消</div>
      <div class="buttonNormalConfirmSmallContain" @click="submit">确认提交</div>
    </div>
  </div>
</template>

<script>
var msg
export default {
  data() {
    return {
      member: {},
      AntiShake: true
    };
  },

  props: ['editData', 'addType', 'title'],

  methods: {
    submit() {
      if (!this.member.cardNum || !this.member.personName) {
        return this.$message.error('请将基础信息填写完整！')
      }
      if (!this.member.phone && this.title != '成员信息') {
        return this.$message.error('请将基础信息填写完整！')
      }
      this.$debounce(this.$emit('submitAdd', this.member),1000)
      
    },
    clickPage() {
      if (msg) {
        msg.close()
      }
    },
    beforeDestroy() {
      if (msg) {
        msg.close()
      }
    },
    back() {
      this.$parent.showAddMember = false
    }
  },

  created() {
    if (this.addType == 'edit') {
      this.member = this.editData
    }
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.addMember{
  position: relative;
  &.addMember_mobile{
    .itemCard{
      background: #FDFBF7;
      box-shadow: 0px 0.05rem 0.26rem rgba(0, 0, 0, 0.08);
      margin: 0.5rem 0.4rem;
      padding-top: 1.8rem !important;
      position: relative;
      border-radius: 0.416rem;
      &:before{
        position: absolute;
        content: '';
        display: inline-block;
        top: 0.08rem;
        left: 0.08rem;
        width: 9.04rem;
        height: 1.2rem;
        background: linear-gradient(180deg, #F7E9DE 0%, rgba(242, 230, 208, 0) 100%);
        border-radius: 0.416rem 0.416rem 0px 0px;
      }
    }
    .itemCardTitle{
      position: absolute;
      left: 0.65rem;
      top: 0.5rem;
      font-size: 0.494rem;
    }

  }
  .back{
    position: absolute;
    left: 0.6rem;
    bottom: 0.15rem;
    font-size: 0.45rem;
  }
  &.pcMember{
    position: relative;
    top: unset;
    align-items: center;
    .contentTitle{
      margin: 0.2rem;
      font-size: 0.3rem;
    }
    .itemCard{
      margin: 0.2rem;
      padding: 0.3rem;
      border-radius: 0.1rem;
    }
    .lineContent{
      .name{
        font-size: 0.2rem;
        width: 2rem;
      }
    }
    .buttonNormal{
      margin: auto;
      margin-top: 0.5rem;
      width: 2rem;
      height: 0.5rem;
      font-size: 0.3rem;
      line-height: 0.5rem;
    }
  }
  .contentTitle{
    margin: 0.5rem;
    margin-top: 1rem;
  }
  .lineContent{
    .name{
      width: 2.5rem;
    }
  }
  .buttonNormal{
    margin-top: 2rem;
  }
  .backButtons{
    margin-top: 1.5rem;
    .buttonNormalConfirmSmallContain{
      margin: auto;
    }
  }
}
</style>
<style type="text/css" lang="scss">
  .pcMember input{
    height: 0.6rem !important;
    font-size: 0.2rem !important;
    width: 100% !important;
  }
  .addMember_mobile .lineContent{
    .el-input__inner{
      line-height: 1rem;
    }
  }
</style>